import {
  DELETE_BUILDS_FAILED,
  DELETE_BUILDS_LOADING,
  DELETE_BUILDS_SUCCESS,
  RESET_BULK_BUILDS_FOR_DELETION,
  SET_BUILDS_TO_DELETE,
  SET_IS_BUILD_DELETE_CTA_CLICKED,
  TOGGLE_BULK_BUILD_DELETE
} from "../actionTypeConstants/bulkBuildDeleteConstants";

const initialState = {
  buildDeleteState: {
    data: {},
    error: null,
    loading: false
  },
  isDeleteBuildsBtnActive: false,
  isDeleteBuildCtaClicked: false,
  selectedBuilds: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_BULK_BUILD_DELETE: {
      return {
        ...state,
        isDeleteBuildsBtnActive: action.payload
      };
    }

    case SET_BUILDS_TO_DELETE: {
      return {
        ...state,
        selectedBuilds: action.payload
      };
    }

    case DELETE_BUILDS_LOADING: {
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          data: null,
          error: null,
          loading: true
        }
      };
    }

    case DELETE_BUILDS_SUCCESS: {
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          data: action.result.data,
          error: null,
          loading: false
        }
      };
    }

    case DELETE_BUILDS_FAILED: {
      return {
        ...state,
        buildDeleteState: {
          ...state.buildDeleteState,
          data: null,
          error: action.error.response,
          loading: false
        }
      };
    }

    case SET_IS_BUILD_DELETE_CTA_CLICKED: {
      return {
        ...state,
        isDeleteBuildCtaClicked: action.payload
      };
    }

    case RESET_BULK_BUILDS_FOR_DELETION: {
      return {
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
}
